import { useState } from "react";
import { Outlet } from "react-router-dom";

function SetPasswordContainer() {
  const [password, setPassword] = useState("");
  return (
    <>
      <Outlet context={[password, setPassword]} />
    </>
  );
}

export default SetPasswordContainer;
